<template>
  <div>
    <div class="searchMain">
      <div class="searchItem">
        <div class="labelName">经销商：</div>
        <el-select v-model="dealerId" placeholder="请选择经销商" filterable remote :remote-method="remoteMethod"
          :loading="loading" @change="chooseDearler" clearable>
          <el-option v-for="dealer in dealerList" :key="dealer.id" :label="dealer.dealerName" :value="dealer.id" />
        </el-select>
      </div>
    </div>
    <!-- 修改布局容器样式 -->
    <div class="main-layout" v-loading="loading" element-loading-text="拼命加载中...">
      <div class="left-modules">
        <div class="module">
          <h2>设备统计</h2>
          <div class="stats-grid">
            <div class="stat-item">
              <p>未使用设备总数</p>
              <h3 @click="goToDeviceManagement">{{ unusedDevices }}</h3>
            </div>
            <div class="stat-item">
              <p>已使用设备总数</p>
              <h3 @click="goToDeviceManagement1">{{ usedDevices }}</h3>
            </div>
          </div>
        </div>
        <div class="module">
          <h2>经销商统计</h2>
          <div class="stats-grid">
            <div class="stat-item" @click="goToDealerManagement">
              <p>经销商总数</p>
              <h3>{{ totalDealers }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div id="container" class="gpsMapContainer"></div>
      <div class="right-module">
        <div class="module">
          <h2>设备状态统计</h2>
          <div class="stats-grid column">
            <div class="stat-item" @click="showDeviceList(2)">
              <p>正常设备</p>
              <h3>{{ normalDevices }}</h3>
            </div>
            <div class="stat-item" @click="showDeviceList(1)">
              <p>正在运输中设备</p>
              <h3>{{ transportingDevices }}</h3>
            </div>
            <div class="stat-item" @click="showDeviceList(3)">
              <p>疑似窜货设备总数</p>
              <h3>{{ totalSuspiciousDevices }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播组件 -->
    <channelRealData ref="channelRealData" :realData="realData"></channelRealData>

    <el-dialog :title="dialogTitle" :visible.sync="showAlarmDialog" width="50%" :modal-append-to-body="false">
      <commonTable :tableData="alarms" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
        <template v-slot:table>
          <el-table-column prop="dealerName" label="代理商" align="center"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
          <el-table-column prop="createTime" label="出货日期" align="center"></el-table-column>
          <el-table-column prop="updateTime" :label="currentStatus === 3 ? '报警日期' : '最后更新时间'" align="center"></el-table-column>
          <el-table-column v-if="currentStatus === 3" prop="fleeingAddress" label="窜货地" align="center"></el-table-column>
        </template>
      </commonTable>
    </el-dialog>
  </div>
</template>

<script>
  // import { Table as ElTable, TableColumn as ElTableColumn } from 'element-ui';
  window._AMapSecurityConfig = {
    securityJsCode: "5d37c3f55c95ad6578fde2dfade70be1",
  };
  import AMapLoader from "@amap/amap-jsapi-loader";
  import channelRealData from "./components/channelRealData";
  import {
    getNum,
    getDealerNum,
    getSuspectNum,
    warning,
    mapShow,
  } from "@/api/gps.js";
  import { fetchDealList } from "@/api/companyManage.js";
  import commonTable from "@/components/common/commonTable";
  export default {
    components: {
      // ElTable,
      // ElTableColumn,
      commonTable,
      channelRealData,
    },
    data() {
      return {
        unusedDevices: 0,
        usedDevices: 0,
        totalDealers: 0,
        transportingDevices: 0,
        suspiciousDevices: 0,
        normalDevices: 0,
        totalSuspiciousDevices: 0,
        alarms: [],
        showAlarmDialog: false, // 新增控制弹窗显示的变量
        currentStatus: null, // 当前弹窗展示的状态类型 1运输中 2正常 3已窜货
        pageSize: 10,
        pageNum: 1,
        total: 0,
        mapData: [],
        map: null,
        realData: [],
        dealerId: null,
        dealerList: [],
        loading: false,
      };
    },
    created() {
      this.getMapData();
      this.getRealData();
      this.getDealerList();
    },
    methods: {
      remoteMethod(query) {
        if (query !== "") {
          this.dealerList = [];
          this.loading = true;
          this.getDealerList(query);
        } else {
          this.dealerList = [];
        }
      },
      getDealerList(dealerName) {
        this.loading = false;
        let params = {
          pageNum: 1,
          pageSize: 200,
          dealerName,
          isMap: 1,
        };
        fetchDealList(params).then((res) => {
          if (res.data) {
            this.dealerList = res.data.list;
          }
        });
      },
      chooseDearler() {
        this.loading = true;
        this.getMapData(this.dealerId);
      },
      getMapData(dealerId) {
        let that = this;
        let params = {
          dealer: dealerId ? dealerId : null,
        };
        mapShow(params).then((res) => {
          this.mapData = res.data;
          this.$nextTick(() => {
            that.initMapWithData();
          });
          this.loading = false;
        });
      },
      initMapWithData() {
        const MAP_PLUGINS = [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.ControlBar",
          "AMap.HawkEye",
          "AMap.Circle",
          "AMap.Polygon",
          "AMap.Polyline",
          "AMap.Marker",
          "AMap.Pixel",
          "AMap.InfoWindow",
          "AMap.Icon",
          "AMap.MarkerCluster",
          "AMap.MoveAnimation",
          "AMap.GraspRoad",
          "AMap.DistrictSearch",
        ];
        AMapLoader.reset();
        AMapLoader.load({
          key: "db71672d95f583129da44bbe6c679a58",
          version: "2.0",
          plugins: MAP_PLUGINS,
        }).then((AMap) => {
          const map = new AMap.Map("container", {
            viewMode: "3D",
            terrain: true,
            zoom: 4,
            center: [116.41, 39.91],
          });

          const textMarkers = []; // 存放文字标注

          const district = new AMap.DistrictSearch({
            subdistrict: 1, // 只查下一级省
            extensions: "base", // 需要边界
            level: "country", // 查询中国
          });

          district.search("中国", function (status, result) {
            const provinces = result.districtList[0].districtList;
            provinces.forEach((province) => {
              const center = province.center; // [lng, lat]
              const name = province.name;
              // 放置标注
              const text = new AMap.Text({
                text: name,
                position: center,
                map: map,
                style: {
                  "font-size": "12px",
                  color: "#333",
                  padding: "2px 4px",
                  border: "none",
                  "background-color": "transparent",
                },
              });

              textMarkers.push(text);
            });
          });

          this.map = map;

          map.on("zoomend", () => {
            const currentZoom = map.getZoom();
            textMarkers.forEach((text) => {
              if (currentZoom > 4.8) {
                text.hide();
              } else {
                text.show();
              }
            });
          });

          // 定义三种颜色
          // status 1运输中 蓝色 2正常 绿色 3 窜货 红色
          let colorMap = {
            1: "https://apkpic.86122m.com/mktpic/fyyun/marker_blue.png", // 蓝色
            2: "https://apkpic.86122m.com/mktpic/fyyun/marker_green.png", // 绿色
            3: "https://apkpic.86122m.com/mktpic/fyyun/marker_red.png", // 红色
          };
          this.mapData.forEach((item, index) => {
            const position = [item.lon, item.lat];
            const iconUrl = colorMap[item.status];

            const marker = new AMap.Marker({
              position: position,
              icon: new AMap.Icon({
                size: new AMap.Size(30, 30),
                image: iconUrl,
                imageSize: new AMap.Size(30, 30),
              }),
              map: map,
            });

            // 创建信息窗口
            var info = [];
            info.push(
              `<p class='input-item'><strong>设备名称 :</strong>  ${item.deviceName}</p>`
            );
            info.push(
              `<p class='input-item'><strong>地址</strong> : ${item.address}</p>`
            );
            // 添加 data-dealer-id 属性
            info.push(
              `<div class="view-details-btn" style="width: 100px;
    height: 30px;
    background: #51CDCB;
    color:#fff;
    display: flex;
    justify-content: center;
    font-size: 14px;
    margin-top: 10px;
    cursor: pointer;
    align-items: center;" data-device-id="${item.deviceId}" data-dealer-id="${item.dealerId}">查看轨迹</div>`
            );
            const infoWindow = new AMap.InfoWindow({
              content: info.join(""),
              offset: new AMap.Pixel(25, -10),
            });

            marker.on("click", () => {
              infoWindow.open(map, position);
              // 信息窗口打开后，添加点击事件监听器
              this.$nextTick(() => {
                const btn = document.querySelector(
                  `.view-details-btn[data-device-id="${item.deviceId}"]`
                );
                if (btn) {
                  btn.addEventListener("click", () => {
                    // 获取经销商 ID
                    const dealerId = btn.dataset.dealerId;
                    console.log("item", item);

                    this.getLngLat(item.deviceId, dealerId, item.endTime, item.startTime);
                  });
                }
              });
            });
          });
        });
      },
      getLngLat(deviceId, dealerId, endTime, startTime) {
        console.log("设备ID:", deviceId, "经销商ID:", dealerId);
        // 不传时间，设备轨迹页按最后定位时间往前推7天
        this.$router.push({
          path: "/gps/gj",
          query: {
            deviceId: deviceId,
            dealerId: dealerId,
          },
        });
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.fetchAlarmList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.fetchAlarmList();
      },
      goToDeviceManagement() {
        //   页面跳转
        this.$router.push({
          path: "device",
          query: {
            fromStatistics: true,
            deviceStatus: 0,
          },
        });
      },
      goToDeviceManagement1() {
        //   页面跳转
        this.$router.push({
          path: "device",
          query: {
            fromStatistics: true,
            deviceStatus: 1,
          },
        });
      },
      goToDealerManagement() {
        this.$router.push({ path: "gpsDealer" });
      },
      showDeviceList(status) {
        this.currentStatus = status;
        this.pageNum = 1;
        this.showAlarmDialog = true;
        this.fetchAlarmList();
      },
      fetchAlarmList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          status: this.currentStatus,
        };
        warning(params).then((res) => {
          console.log(res.data.list);
          this.alarms = res.data.list;
          this.total = res.data.total;
        });
      },
      getRealData() {
        let params = {
          pageNum: 1,
          pageSize: 100,
        };
        warning(params).then((res) => {
          const list = (res.data && res.data.list) || [];
          this.realData = list.filter(
            (item) => this.hasDisplayText(item.dealerName) && this.hasDisplayText(item.deviceName)
          );
        });
      },
      hasDisplayText(val) {
        return val != null && String(val).trim() !== "" && String(val).trim() !== "-";
      },
      // 获取数据
      getData() {
        getNum().then((res) => {
          console.log(res);
          this.unusedDevices = res.data.notUsed;
          this.usedDevices = res.data.already;
        });
      },
      getDealer() {
        getDealerNum().then((res) => {
          console.log(res);
          this.totalDealers = res.data.total;
        });
      },
      getSuspect() {
        getSuspectNum().then((res) => {
          console.log(res);
          this.totalSuspiciousDevices = res.data.total;
          this.transportingDevices = res.data.use;
          this.normalDevices = res.data.suspect;
        });
      },
    },
    computed: {
      dialogTitle() {
        if (this.currentStatus === 1) return '运输中设备列表';
        if (this.currentStatus === 2) return '正常设备列表';
        if (this.currentStatus === 3) return '窜货数据展示';
        return '设备列表';
      }
    },
    mounted() {
      // Fetch data from API
      this.getData();
      this.getDealer();
      this.getSuspect();
    },
  };
</script>

<style scoped>
  /* 新增主要布局样式 */
  .main-layout {
    display: flex;
    height: 100%;
    justify-content: space-between;
  }

  /* 左侧模块样式，设置宽度为 30% */
  .left-modules {
    width: 20%;
    margin-right: 10px;
  }

  /* 右侧模块样式，设置宽度为 30% */
  .right-module {
    width: 20%;
    margin-left: 10px;
  }

  /* 原有样式保持不变 */
  #map {
    width: 100%;
    height: 400px;
    background-color: #e0e0e0;
    border: 1px solid #ccc;
    margin-top: 20px;
  }

  h1 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  }

  .module {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 8px;
    background-color: #f9f9f9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .module h2 {
    color: #444;
    margin-bottom: 20px;
  }

  .stats-grid {
    /* 修改为单列布局 */
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .stat-item {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: transform 0.2s ease;
  }

  /* 设备状态统计 - 疑似窜货设备总数 */
  .right-module .module .stat-item:nth-child(3) {
    background-color: #ee7884;
    /* 浅红色 */
    cursor: pointer;
  }

  .stat-item:hover {
    transform: translateY(-5px);
  }

  .stat-item p {
    color: #555;
    margin-bottom: 10px;
  }

  .stat-item h3 {
    color: #007bff;
    margin-bottom: 15px;
    /* cursor: pointer; */
  }

  /* 为特定元素添加手型光标 */
  /* 未使用设备总数 */
  .left-modules .module:nth-child(1) .stat-item:nth-child(1) {
    background-color: #e3f2fd;
    cursor: pointer;
  }

  /* 已使用设备总数 */
  .left-modules .module:nth-child(1) .stat-item:nth-child(2) {
    background-color: #bbdefb;
    cursor: pointer;
  }

  /* 经销商总数 */
  .left-modules .module:nth-child(2) .stat-item {
    background-color: #90caf9;
    cursor: pointer;
  }

  /* 设备状态统计 - 正常设备 */
  .right-module .module .stat-item:nth-child(1) {
    background-color: #c8e6c9;
    cursor: pointer;
  }

  /* 设备状态统计 - 正在运输中设备 */
  .right-module .module .stat-item:nth-child(2) {
    background-color: #a5d6a7;
    cursor: pointer;
  }

  /* 设备状态统计 - 疑似窜货设备总数 */
  .right-module .module .stat-item:nth-child(3) {
    background-color: #ee7884;
    cursor: pointer;
    /* 显示手型光标 */
  }

  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #0056b3;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }

  table,
  th,
  td {
    border: 1px solid #ddd;
  }

  th,
  td {
    padding: 10px;
    text-align: left;
  }

  th {
    background-color: #f8f8f8;
  }

  /* 设备统计 - 未使用设备 */
  .left-modules .module:nth-child(1) .stat-item:nth-child(1) {
    background-color: #e3f2fd;
    /* 浅蓝色 */
  }

  /* 设备统计 - 已使用设备 */
  .left-modules .module:nth-child(1) .stat-item:nth-child(2) {
    background-color: #bbdefb;
    /* 浅天蓝色 */
  }

  /* 经销商统计 */
  .left-modules .module:nth-child(2) .stat-item {
    background-color: #90caf9;
    /* 天蓝色 */
  }

  /* 设备状态统计 - 正常设备 */
  .right-module .module .stat-item:nth-child(1) {
    background-color: #c8e6c9;
    /* 浅绿色 */
  }

  /* 设备状态统计 - 正在运输中设备 */
  .right-module .module .stat-item:nth-child(2) {
    background-color: #a5d6a7;
    /* 浅草绿色 */
  }

  /* 设备状态统计 - 疑似窜货设备总数 */
  .right-module .module .stat-item:nth-child(3) {
    background-color: #ee7884;
    /* 浅红色 */
  }

  .gpsMapContainer {
    border: 1px solid #eee;
    min-width: 800px;
    min-height: 500px;
    width: 100%;
    height: 60vh;
  }

  .custom-input-card {
    width: 18rem;
  }

  .custom-input-card .btn:last-child {
    margin-left: 1rem;
  }

  .content-window-card {
    position: relative;
    width: 23rem;
    padding: 0.75rem 0 0 1.25rem;
    box-shadow: none;
    bottom: 0;
    left: 0;
  }

  .content-window-card p {
    height: 2rem;
  }

  .view-details-btn {
    width: 200px;
    height: 100px;
    background: #007bff;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .column {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .searchMain {
    position: absolute;
    top: 88px;
    left: 281px;
    z-index: 99;
  }

  .searchItem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>